import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const loadRequests: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { collectionApi },
) =>
  action$.pipe(
    ofType(actions.REQUESTS_ACTIONS.REQUESTED),
    switchMap(() => {
      return collectionApi.getRequests().pipe(
        switchMap(({ requests }) => of(actions.requestsSucceeded(requests))),
        catchError(error => of(actions.requestsFailed(error))),
      );
    }),
  );



// WEBPACK FOOTER //
// ./src/scenes/Requests/services/epics/loadRequests.ts